import { useEffect } from 'react';

const useMount = (handler) => useEffect(handler, []);

export default useMount;
